import { render, staticRenderFns } from "./CreateOrUpdate.vue?vue&type=template&id=60cb8a03&"
import script from "./CreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports